import React from 'react';
// import './loading.scss';
export const Loading = () => {
    return (React.createElement("div", { className: 'k-loading-mask loading-layout-mask' },
        React.createElement("div", { className: 'k-loading-image' }),
        React.createElement("div", { className: 'k-loading-color' })));
};
